import { Paper, IconButton, Stack, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Tooltip } from "@mui/material";
import { Suspense } from "react";
import KeyIcon from '@mui/icons-material/Key';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import api from "../../hooks/useApi";
import { useLoaderData, defer, Await, Outlet, NavLink, useRevalidator } from "react-router-dom";
import CenteredSpinner from "../../components/centerVPspinner";
import PageTitle from "../../components/PageTitle";

export async function loader({ request, params }) {
    const response = api.get('/api/users/partners/');
    return defer({
        promise: response,
    });
}

export const statusLabel = (isActive) => isActive ? 'Активний' : 'Відключений';

export async function togglePartnerStatus(client, id, isActive, confirm = window.confirm) {
    if (!confirm(isActive ? 'Відключити партнера?' : 'Активувати партнера?')) return false;
    await client.patch(`/api/users/partners/${id}/`, { is_active: !isActive });
    return true;
}


export default function AllUsers() {
    const users = useLoaderData();

    const revalidator = useRevalidator();

    return (
        <Box sx={{ maxWidth: '100%', width: '100%', overflow: 'auto' }}>
            <PageTitle title="Користувачі" />

            <Suspense fallback={<CenteredSpinner />}>
                <Await
                    resolve={users.promise}
                    errorElement={<Alert severity="error">Невдалось завантажити список користувачів :{'\\'}</Alert>}
                >
                    {(promise) => {
                        //console.log(promise.data.users)
                        return (
                            <>
                                <TableComponent data={promise.data.users} revalidator={revalidator} />
                            </>
                        )
                    }}
                </Await>
            </Suspense>
            <Outlet />
        </Box>
    );
}

const TableHeaderComponent = () => (
    <TableHead>
        <TableRow>
            <TableCell>Ім’я</TableCell><TableCell>Прізвище</TableCell><TableCell>По батькові</TableCell>
            <TableCell>Пошта</TableCell>
            <TableCell>Телефон</TableCell>
            <TableCell>Статус</TableCell><TableCell>Дата створення</TableCell><TableCell>Останній вхід</TableCell>
            <TableCell>Налаштування</TableCell>
        </TableRow>
    </TableHead>
);

const TableRowComponent = ({ data, revalidator }) => {
    const toggle = async () => { if (await togglePartnerStatus(api, data.id, data.is_active)) revalidator.revalidate(); };
    return (
    <TableRow>
        <TableCell>{data.name}</TableCell><TableCell>{data.last_name}</TableCell><TableCell>{data.second_name}</TableCell>
        <TableCell>{data.email}</TableCell>
        <TableCell>{data.phone}</TableCell>
        <TableCell>{statusLabel(data.is_active)}</TableCell><TableCell>{data.date_joined || '—'}</TableCell><TableCell>{data.last_login || '—'}</TableCell>
        <TableCell>
            <Stack direction='row' sx={{ width: '100%', justifyContent: 'center' }}>
                <Tooltip title='Змінити пароль' arrow placement="top">
                    <IconButton component={NavLink} to={`/all-users/${data.id}/password`} aria-label="Змінити пароль" sx={{ color: '#4794FF' }}>
                        <KeyIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title='Редагувати користувача' arrow placement="top">
                    <IconButton component={NavLink} to={`/all-users/${data.id}/details/edit`} aria-label="Редагувати користувача" sx={{ color: '#4794FF' }}>
                        <EditOutlinedIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={data.is_active ? 'Відключити' : 'Активувати'} arrow placement="top">
                    <IconButton onClick={toggle} sx={{ color: '#FF4D4D' }}>
                        <PowerSettingsNewIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
        </TableCell>
    </TableRow>);
};

const TableComponent = ({ data, revalidator }) => (
    <TableContainer component={Paper} elevation={0} style={{ outline: '1px solid #eeeeee' }}>
        <Table >
            <TableHeaderComponent />
            <TableBody>
                {data.map((user, index) => (
                    <TableRowComponent key={user.id} data={user} revalidator={revalidator} />
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);
